// 1.10: decision-taxonomy summaries computed from thread messages.
// Works on EVERY thread (old or new) because the per-decision records have always been
// stored — only the outcome fields are new. Counts here are DECISIONS (pre-gate);
// outcome fields (total_opened/executed_closes), when present, are post-gate book truth.

export interface DecisionTaxonomy {
  take: number;
  reduce: number;
  skip: number;
  close: number;
  hold: number;
  total: number;
}

export function summarizeDecisions(messages: Array<{ decisions?: Array<{ decision?: string }> }> | undefined): DecisionTaxonomy {
  const t: DecisionTaxonomy = { take: 0, reduce: 0, skip: 0, close: 0, hold: 0, total: 0 };
  for (const m of messages || []) {
    for (const d of m.decisions || []) {
      switch (d.decision) {
        case 'TAKE': t.take++; break;
        case 'REDUCE': t.reduce++; break;
        case 'SKIP': t.skip++; break;
        case 'CLOSE': t.close++; break;
        case 'HOLD': t.hold++; break;
        default: continue;
      }
      t.total++;
    }
  }
  return t;
}
